/**
 * undercover® hero
 * - lichte scroll-zoom/parallax (window én .page-wrapper, want Horizon scrollt op desktop daarin)
 * - pauzeknop voor de achtergrondvideo
 * - theme-editor: een geselecteerde doelgroep-variant direct tonen
 * De UTM-personalisatie zelf draait inline in de sectie (vóór de eerste paint).
 */
(() => {
  if (customElements.get('uc-hero')) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class UcHero extends HTMLElement {
    connectedCallback() {
      this.zoom = this.querySelector('.uc-hero__zoom');
      this.content = this.querySelector('[data-hero-content]');
      this.pauseButton = this.querySelector('[data-hero-pause]');
      this.onScroll = this.onScroll.bind(this);
      this.update = this.update.bind(this);

      this.setupVideo();
      this.pauseButton?.addEventListener('click', () => this.togglePause());

      if (this.hasAttribute('data-parallax') && !reduceMotion.matches) {
        this.scrollers = [window, document.querySelector('.page-wrapper')].filter(Boolean);
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          if (this.visible) this.update();
        });
        this.observer.observe(this);
        this.scrollers.forEach((el) => el.addEventListener('scroll', this.onScroll, { passive: true }));
      }

      this.onBlockSelect = (event) => {
        const template = this.querySelector(`template[data-block-id="${event.detail.blockId}"]`);
        if (template && window.ucHeroApply) {
          window.ucHeroApply(this, template);
          this.setupVideo();
        }
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.scrollers?.forEach((el) => el.removeEventListener('scroll', this.onScroll));
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    get video() {
      return this.zoom?.querySelector('video');
    }

    setupVideo() {
      const video = this.video;
      if (this.pauseButton) this.pauseButton.hidden = !video;
      if (!video) return;
      video.muted = true;
      video.playsInline = true;
      if (reduceMotion.matches) {
        video.removeAttribute('autoplay');
        video.pause();
        this.setPaused(true);
        return;
      }
      video.play?.().catch(() => this.setPaused(true));
    }

    togglePause() {
      const video = this.video;
      if (!video) return;
      if (video.paused) {
        video.play().catch(() => {});
        this.setPaused(false);
      } else {
        video.pause();
        this.setPaused(true);
      }
    }

    setPaused(paused) {
      if (!this.pauseButton) return;
      this.pauseButton.classList.toggle('is-paused', paused);
      this.pauseButton.setAttribute(
        'aria-label',
        paused ? this.pauseButton.dataset.labelPlay : this.pauseButton.dataset.labelPause
      );
    }

    onScroll() {
      if (!this.visible || this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(this.update);
    }

    update() {
      this.ticking = false;
      const rect = this.getBoundingClientRect();
      const progress = Math.min(Math.max(-rect.top / rect.height, 0), 1);
      this.zoom.style.transform = `translate3d(0, ${(progress * 14).toFixed(2)}%, 0) scale(${(1 + progress * 0.1).toFixed(4)})`;
      if (this.content) {
        this.content.style.transform = `translate3d(0, ${(progress * -48).toFixed(1)}px, 0)`;
        this.content.style.opacity = String(Math.max(1 - progress * 1.4, 0).toFixed(3));
      }
    }
  }

  customElements.define('uc-hero', UcHero);
})();
